import PostableDraft from "./PostableDraft";

export default PostableDraft;